import client from '../httpClient';

const autoRegistResponseControlUpdateApi = (pathParameter, params) => {
  return client.put(`/responses/automation-controls/${pathParameter}`, JSON.stringify(params));
};

export default autoRegistResponseControlUpdateApi;
